/*
 * @Author: Yolo
 * @Date: 2024-06-25 10:20:39
 * @Last Modified by: Yolo
 * @Last Modified time: 2024-07-17 15:37:07
 * @Desc 风场、海流场
 */
import L from 'leaflet'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
// import 'leaflet-velocity/dist/leaflet-velocity.min.css'
import 'leaflet-velocity'
import { showWeatherTipMessage } from '../util/ShowWeatherTipMessage'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

interface WindyServiceOptions {
  ak: string
  type: number
  data: any
  callback: (done: (list: any) => void) => void
}

interface VelocityLayerConfig {
  header: {
    dx: number
    dy: number
    nx: number
    ny: number
    la1: number
    la2: number
    lo1: number
    lo2: number
    parameterUnit: string
    parameterNumber: number
    parameterCategory: number
    refTime: string
    numberPoints: number
  }
  data: number[]
}

class WindyService {
  _viewState: boolean
  _map: MyMap
  lyGroup: L.LayerGroup = L.layerGroup()
  _isView: boolean
  _velocityLayers: any // 根据实际情况替换成具体的velocityLayer类型
  _forecasttime: any
  _QBBeginTime: any
  options: any = {}
  weatherMsg: any
  constructor(map: MyMap, options?: Partial<WindyServiceOptions>) {
    this._map = map
    this._viewState = false
    this._velocityLayers = undefined
    this._isView = true
    L.Util.extend(this.options, options)
  }
  private _Event = {
    zoomend: () => {
      this._zoomChange()
    },
    baselayerchange: () => {
      this._zoomChange(false, true)
    },
  }

  registEvent() {
    this.offRegistEvent()
    this._map.on('zoomend', this._Event.zoomend)
    this._map.on('baselayerchange', this._Event.baselayerchange)
  }

  offRegistEvent() {
    this._map.off('zoomend', this._Event.zoomend)
    this._map.off('baselayerchange', this._Event.baselayerchange)
    this.weatherMsg && this.weatherMsg.offRegisterEvent()
  }

  init_velocityLayers(forecastTime: string, QBBeginTime: any): boolean {
    const type = this.options.type
    const typeStr = `type_${type}`
    let time = `${CanvasShipUtils.dataFormat(
      new Date(),
      'YYYY-MM-DD'
    )} 20:00:00`
    QBBeginTime[typeStr] && (time = QBBeginTime[typeStr].time)
    console.log(time)
    // const weatherDataUrl = ShipxyOptions.weather.weatherDataUrl
    //   .replace('{k}', (this._map.options as any).ak)
    //   .replace('{type}', `${type}`)
    //   .replace('{time}', time)
    //   .replace('{forecasttime}', forecastTime)

    switch (type) {
      case 13:
        this.weatherMsg = showWeatherTipMessage(this._map, 'showSeaBreeze')
        this.init_velocityLayersCallback()
        break
      case 15:
        this.weatherMsg = showWeatherTipMessage(this._map, 'showHL')
        this.init_OceanCurrentLayersCallback()
    }

    return true
  }

  /**
   * 渲染风场及还流场
   * @param data
   * @param velocityType
   */
  private render(data: any[], velocityType: string) {
    const config: VelocityLayerConfig[] = [
      {
        header: {
          dx: 1,
          dy: 1,
          nx: 360,
          ny: 181,
          la1: 90,
          la2: -90,
          lo1: 0,
          lo2: 359,
          parameterUnit: 'm.s-1',
          parameterNumber: 2,
          parameterCategory: 2,
          refTime: '',
          numberPoints: 65160,
        },
        data: [],
      },
      {
        header: {
          dx: 1,
          dy: 1,
          nx: 360,
          ny: 181,
          la1: 90,
          la2: -90,
          lo1: 0,
          lo2: 359,
          parameterUnit: 'm.s-1',
          parameterNumber: 3,
          parameterCategory: 2,
          refTime: '',
          numberPoints: 65160,
        },
        data: [],
      },
    ]

    // 设置config中header的公共属性
    config[0].header.nx = config[1].header.nx = 360
    config[0].header.ny = config[1].header.ny = 181
    config[0].header.la1 = config[1].header.la1 = 90
    config[0].header.la2 = config[1].header.la2 = -90
    config[0].header.lo1 = config[1].header.lo1 = 0
    config[0].header.lo2 = config[1].header.lo2 = 359
    config[0].header.numberPoints = config[1].header.numberPoints = 65160

    const dataList: any[][] = []

    data.forEach((item: any, index: number, array: any[]) => {
      if (index % 360 === 0) {
        const chunk: any[] =
          index === 0 ? array.slice(-360) : array.slice(-index - 360, -index)
        dataList.push(chunk.slice(-180), chunk.slice(0, 180))
      }
    })

    const allDataItems: any[] = []
    dataList.forEach((itemList) => {
      itemList.forEach((item) => {
        allDataItems.push(item)
      })
    })

    const uComponents: number[] = []
    const vComponents: number[] = []
    const radian = Math.PI / 180

    for (const allDataItem of allDataItems) {
      const values = allDataItem.value.split('/')
      let direction = Number.parseFloat(values[1])
      let speed = Number.parseFloat(values[0])

      if (velocityType === '海流场') {
        direction = Math.round(direction)

        if (
          Number.isNaN(speed) ||
          Math.abs(speed) === 32767 ||
          speed <= 0.012
        ) {
          speed = 0
        } else {
          speed *= 50
        }
      } else {
        if (Number.isNaN(speed) || speed === 32767) {
          speed = 0
        }
      }

      const uComponent = speed * Math.sin(direction * radian)
      const vComponent = speed * Math.cos(direction * radian)

      uComponents.push(-uComponent)
      vComponents.push(-vComponent)
    }

    config[0].data = uComponents
    config[1].data = vComponents

    if (this._velocityLayers) {
      this._velocityLayers.setData(config)
    } else {
      this._velocityLayers = (L as any).velocityLayer({
        displayValues: false,
        displayOptions: {
          velocityType,
          displayPosition: 'bottomright',
          displayEmptyString: '无数据',
        },
        data: config,
        maxVelocity: 15,
        colorScale: [
          '#2468B4',
          '#3C9DC2',
          '#80CDC1',
          '#97DAA8',
          '#C6E7B5',
          '#EEF7D9',
          '#FCD97D',
          '#FFB664',
          '#FC964B',
          '#FA7034',
          '#F54020',
          '#ED2D1C',
          '#DC1820',
          '#B40023',
        ],
        elaneMap: this._map,
        frameRate: 15,
        opacity: 1,
      })

      this._map.addLayer(this._velocityLayers)
    }

    this._velocityLayers._clearWind()
    setTimeout(() => {
      this._velocityLayers._startWindy()
    }, 200)
  }

  init_velocityLayersCallback() {
    const done = (list: any) => {
      this.render(list, '风场')
    }
    if (this.options.callback) {
      this.options.callback(done)
      return
    }
    done(this.options.data)
  }

  init_OceanCurrentLayersCallback() {
    const done = (list: any) => {
      this.render(list, '海流场')
    }
    if (this.options.callback) {
      this.options.callback(done)
      return
    }
    done(this.options.data)
  }

  show(forecastTime: string, QBBeginTime: any) {
    this._isView = true
    this._forecasttime = forecastTime
    this._QBBeginTime = QBBeginTime
    this.registEvent()

    if (this.init_velocityLayers(this._forecasttime, this._QBBeginTime)) {
      this._velocityLayers._clearWind()
      setTimeout(() => {
        this._velocityLayers._startWindy()
      }, 200)
    }
  }

  _zoomChange(isRemove?: boolean, isClearLayer?: boolean) {
    if (this._map.getZoom() >= 2 && this._isView) {
      if (isClearLayer) {
        this._velocityLayers._clearWind()
        setTimeout(() => {
          this._velocityLayers._startWindy()
        }, 400)
      } else {
        this._velocityLayers._startWindy()
      }
    } else {
      this._hide(isRemove)
    }
  }

  hide() {
    this._isView = false
    this._hide(true)
  }

  _hide(isRemove?: boolean) {
    this.offRegistEvent()
    this.lyGroup && this.lyGroup.clearLayers()
    if (this._velocityLayers) {
      this._velocityLayers._clearWind()
      if (isRemove) {
        this._velocityLayers.remove()
        this._velocityLayers = undefined
      }
    }
  }
}

const windyService = (
  map: MyMap,
  options?: Partial<WindyServiceOptions>
): WindyService => {
  return new WindyService(map, options)
}

export { WindyService, windyService }
